import type { TabTitleType } from "../types";

export const defaultTabId = (
  titles: TabTitleType[],
  dynamicVariable?: string,
) => {
  const defaultTab = titles.find((title) => title.isDefault);
  if (dynamicVariable && isValidDynamicVariable(dynamicVariable)) {
    const index = Number.parseInt(dynamicVariable);
    return titles[index]?.id || titles[0]?.id;
  }
  return defaultTab?.id || titles[0]?.id;
};

export const isValidDynamicVariable = (dynamicVariable: string) => {
  try {
    const index = Number.parseInt(dynamicVariable);
    return !isNaN(index);
  } catch (err) {
    return false;
  }
};
